import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import Money from "../../utils/Money";


export default class AdvertisingBillingView extends Component {

    static propTypes = {
        selectedMonth: PropTypes.number.isRequired,
        selectedYear: PropTypes.number.isRequired,
        paidReservations:
            PropTypes.arrayOf(
                PropTypes.shape({
                    reservation: PropTypes.shape({
                            advertisementId: PropTypes.number.isRequired,
                            advertisementTitle: PropTypes.string.isRequired,
                            spaceId: PropTypes.number.isRequired,
                            spaceTitle: PropTypes.string.isRequired,
                            startDate: PropTypes.string.isRequired,
                            endDate: PropTypes.string.isRequired,
                            created: PropTypes.number.isRequired,
                        }).isRequired,
                    amount: PropTypes.number.isRequired
                })).isRequired
    };

    handleYearSelectChange = (e) => {
        EventPublisher.publish(
            UIInteractionEvents.ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED,
            {
                selectedYear: parseInt(e.target.value, 10),
                selectedMonth: this.props.selectedMonth
            });
    };

    handleMonthSelectChange = (e) => {
        EventPublisher.publish(
            UIInteractionEvents.ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED,
            {
                selectedYear: this.props.selectedYear,
                selectedMonth: parseInt(e.target.value, 10)
            });
    };

    handlePreviewSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.SPACE_DETAILS_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handlePreviewAdvertisementClick = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    render() {

        const yearsToSelectFrom = Array.from({length: Time.getCurrentYear() - 2020 + 1}, (v,k)=> k+2020);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Advertisement Billing
                            </div>
                            <div className="card-body">
                                <div className="row justify-content-center mb-2">
                                    <form className="form-inline">
                                        <select
                                                className="form-control custom-select"
                                                defaultValue={this.props.selectedYear}
                                                onChange={this.handleYearSelectChange}
                                        >
                                            {yearsToSelectFrom.map((year) => {
                                                return (
                                                    <option key={"year_"+year} value={year}>
                                                        {year}
                                                    </option>);
                                            })}
                                        </select>
                                        <select
                                                className="form-control custom-select"
                                                defaultValue={this.props.selectedMonth}
                                                onChange={this.handleMonthSelectChange}
                                        >
                                            {months.map((month, monthIndex) => {
                                                return(
                                                    <option key={"month_"+month} value={monthIndex}>
                                                        {month}
                                                    </option>);
                                            })}
                                        </select>
                                    </form>
                                </div>
                                <div className="row justify-content-center">
                                    {this._renderBillingContents()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _renderBillingContents() {
        if (this.props.paidReservations.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no payments for the selected month.
                    <br/>
                    Try selecting a different month.
                </div>
            ); // TODO - add a link to help here "if this is an error"
        }

        const monthSum =
            this.props.paidReservations.map((res) => res.amount).reduce((acc, cur) => acc + cur);

        return (
            <div className="table-responsive">
                <table className="table table-sm">
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">Paid Date</th>
                        <th scope="col">Advertisement</th>
                        <th scope="col">Space</th>
                        <th scope="col">Reservation Dates</th>
                        <th scope="col">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                        {this.props.paidReservations.map((paidReservation) => {
                            return (
                                <tr key={"a-"+paidReservation.reservation.advertisementId+"-s-"+paidReservation.reservation.spaceId}>
                                    <td>
                                        {Time.stringifyDate(new Date(paidReservation.reservation.created * 1000))}
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-link"
                                            onClick={(e) =>
                                                this.handlePreviewAdvertisementClick(paidReservation.reservation.advertisementId)}
                                        >
                                            {paidReservation.reservation.advertisementTitle}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-link"
                                            onClick={(e) =>
                                                this.handlePreviewSpaceClick(paidReservation.reservation.spaceId)}
                                        >
                                            {paidReservation.reservation.spaceTitle}
                                        </button>

                                    </td>
                                    <td>
                                        {paidReservation.reservation.startDate + " -> " + paidReservation.reservation.endDate}
                                    </td>
                                    <td>
                                        {Money.formatMoney(paidReservation.amount)}
                                    </td>
                                </tr>
                            );
                        })}
                        <tr className="table-success">
                            <td colSpan={4} className="text-right mr-1">
                                <strong>
                                    Sum:
                                </strong>
                            </td>
                            <td>
                                {Money.formatMoney(monthSum)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

};

